import bridge from "./bridge";
import utils from "../utils";
import { debounce } from "lodash";

function presentLoginDialog() {
  return new Promise((resolve, reject) => {
    bridge.callHandler("presentLoginDialog", {}, resolve);
  });
}

function commentTopic({ topic_type, topic_id, topic_url }) {
  return new Promise((resolve, reject) => {
    bridge.callHandler(
      "commentTopic",
      { topic_type, topic_id, topic_url },
      resolve
    );
  });
}

function viewTopicAllComments({ topic_type, topic_id, parent_id, nick_name }) {
  return new Promise((resolve, reject) => {
    bridge.callHandler(
      "viewTopicAllComments",
      { topic_type, topic_id, parent_id, nick_name },
      resolve
    );
  });
}

function replyUser({ topic_type, topic_id, parent_id, nick_name, topic_url }) {
  return new Promise((resolve, reject) => {
    bridge.callHandler(
      "replyUser",
      { topic_type, topic_id, parent_id, nick_name, topic_url },
      resolve
    );
  });
}

function viewUserAllReplies({
  topic_type,
  topic_id,
  parent_id,
  nick_name,
  topic_url
}) {
  return new Promise((resolve, reject) => {
    bridge.callHandler(
      "viewUserAllReplies",
      { topic_type, topic_id, parent_id, nick_name, topic_url },
      resolve
    );
  });
}

function bodyHeightChanged({ height }) {
  return new Promise((resolve, reject) => {
    console.log("通知客户端高度变化: " + height);
    bridge.callHandler("bodyHeightChanged", { height }, resolve);
  });
}

function previewImage({ currentImg, imgList = [] }) {
  return new Promise((resolve, reject) => {
    bridge.callHandler("previewImage", { currentImg, imgList }, resolve);
  });
}

function pay({ target_id, target_type, paymentConfig, preview }) {
  return new Promise((resolve, reject) => {
    bridge.callHandler(
      "pay",
      { target_type, target_id, paymentConfig, preview },
      resolve
    );
  });
}

function goToAppStore({ settings }) {
  return new Promise((resolve, reject) => {
    bridge.callHandler("goToAppStore", { settings }, resolve);
  });
}

function showSharePopup(options) {
  return setSharePopup({
    ...options,
    showPopup: true
  });
}

function setSharePopup({
  zhugeConfig,
  showPopup = false,

  title, // 分享标题
  desc, // 分享内容
  cover, // 分享图标
  link, // 分享链接

  image // 传image时, 为分享纯图片, 忽略以上参数, 图片可能为url外链, 也可能是base64
}) {
  return new Promise((resolve, reject) => {
    const params = {
      zhugeConfig,

      title,
      desc,
      cover,
      link,

      image
    };
    const methodName = showPopup ? "showSharePopup" : "setSharePopup";
    bridge.callHandler(methodName, params, resolve);
  });
}

function saveFile({ file }) {
  return new Promise((resolve, reject) => {
    bridge.callHandler("saveFile", { file }, resolve);
  });
}

function tokenHasExpired({ token }) {
  return new Promise((resolve, reject) => {
    bridge.callHandler("tokenHasExpired", { token }, resolve);
  });
}

function scrollToCommentsList(domCommentsList, offset) {
  return new Promise((resolve, reject) => {
    const top = utils.getScrollIntoViewTopValue(
      domCommentsList,
      undefined,
      offset
    );
    bridge.callHandler("scrollToCommentsList", { top }, resolve);
  });
}

function setShareButtonVisible(visible) {
  return new Promise((resolve, reject) => {
    bridge.callHandler("setShareButtonVisible", { visible }, resolve);
  });
}

const setShareButtonVisibleDebounce = debounce(setShareButtonVisible, 500);

function pushWebUrl(url) {
  return new Promise((resolve, reject) => {
    bridge.callHandler("pushWebUrl", { url }, resolve);
  });
}

function nativeToast({ content, duration }) {
  return new Promise((resolve, reject) => {
    bridge.callHandler("nativeToast", { content, duration }, resolve);
  });
}

function showLessonServiceTerms() {
  return new Promise((resolve, reject) => {
    bridge.callHandler("showLessonServiceTerms", {}, resolve);
  });
}

function openMiniProgramEvaluationEnjoy() {
  return new Promise((resolve, reject) => {
    bridge.callHandler("openMiniProgramEvaluationEnjoy", {}, resolve);
  });
}

function openInteractChatRoom(params) {
  return new Promise((resolve, reject) => {
    bridge.callHandler("openInteractChatRoom", params, resolve);
  });
}

export default {
  presentLoginDialog,
  commentTopic,
  viewTopicAllComments,
  replyUser,
  viewUserAllReplies,
  bodyHeightChanged,
  previewImage,
  pay,
  goToAppStore,
  showSharePopup,
  setSharePopup,
  saveFile,
  tokenHasExpired,
  scrollToCommentsList,
  setShareButtonVisible,
  setShareButtonVisibleDebounce,
  pushWebUrl,
  nativeToast,
  showLessonServiceTerms,
  openMiniProgramEvaluationEnjoy,
  openInteractChatRoom
};



// WEBPACK FOOTER //
// ./src/utils/bridge/bridgeApis.js